// Frames del camión de Sina (WebP 256px), ordenados por nombre de archivo 01..16.
const modules = import.meta.glob('../../assets/sina-truck/*.webp', { eager: true, import: 'default' });

export const SINA_TRUCK_FRAMES = Object.freeze(
  Object.keys(modules).sort().map((path) => modules[path]),
);

export const SINA_TRUCK_FRAME_MS = 80;
export const SINA_TRUCK_EXIT_MS = 240;

let preloaded = false;

// Decodifica los frames antes de la primera acción para que la animación no parpadee.
export function preloadSinaTruckFrames() {
  if (preloaded || typeof Image === 'undefined') return;
  preloaded = true;
  SINA_TRUCK_FRAMES.forEach((src) => { const img = new Image(); img.src = src; });
}
